import $ from 'jquery';
import { Link } from 'react-router-dom';
import useMenu from '../framework/hooks/useMenuHook';
import scripts from './scripts/Scripts';
import useExtraFields from '../framework/hooks/useExtraHook';
import NieuwsbriefForm from './form/NieuwsbriefForm';

export default function Navigation({ page }) {
    scripts();
    $('html').removeClass('fixed');

    const menu = useMenu();
    const extraFields = useExtraFields();
    function isTip(e) {
        return e.script == 'project' ? 'tip' : '';
    }

    function toggle() {
        $('html').addClass('fixed');
        $('.header-mobile-area').toggleClass('show');
        $('.bar-wrap').toggleClass('active');
        if ($('.header-mobile-area').hasClass('show')) {
            $('.header-mobile-area').css('visibility', 'visible');
            $('.header-mobile-area').css('opacity', '1');
            $('.header-mobile-area .shape').css('transform', 'scale(100)');
            $('.main-menu').delay(200).animate({ marginLeft: 0, opacity: 1 }, 200);
            $('.menu-info-wrapper').delay(200).animate({ marginLeft: 0, opacity: 1 }, 200);
            // $('.logo').addClass('active');
            $('.main-menu ul li a').each(function (index) {
                $(this)
                    .delay(index * 85)
                    .animate({ paddingLeft: '0px' }, 100, function () {
                        $(this).addClass('visible');
                    });
            });
        } else {
            $('html').removeClass('fixed');
            $('.header-mobile-area .shape').css('transform', 'scale(0)');
            $('.main-menu').delay(200).animate({ marginLeft: '30px', opacity: 0 }, 200);
            $('.menu-info-wrapper').delay(200).animate({ marginLeft: '30px', opacity: 0 }, 200);
            $('.header-mobile-area')
                .delay(200)
                .animate({ visibility: 'hidden', opacity: 0 }, 200, function () {
                    $('.header-mobile-area').delay(200).css('visibility', 'hidden');
                    $('.main-menu ul li a').delay(200).css('padding-left', '60px').removeClass('visible');
                });
        }
        loop();
    }

    return (
        <>
            <div className="header-area sticky-header header-area-left logo-light">
                <div className="header-layout header__logo  js-replace">
                    <div className="logo js-replace__item">
                        <div className="js-replace__content">
                            <a href="/">
                                <img src="/assets/img/logo/Logo_wit.svg" alt="logo" />
                            </a>
                        </div>
                    </div>

                    <div className="logo js-replace__item js-replace__item--active">
                        <div className="js-replace__content">
                            <a href="/">
                                <img src="/assets/img/logo/Logo_blauw.svg" alt="logo" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="header-area sticky-header header-area-right">
                <div className="header-layout">
                    <div className="menu-bar">
                        <div className="bar-wrap" onClick={toggle}>
                            <div className="bar-wrap-open">
                                <div className="bar-1" />
                                <div className="bar-2" />
                                <div className="bar-3" />
                            </div>
                            <div className="bar-wrap-close">
                                <div className="bar-1" />
                                <div className="bar-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="header-mobile-area">
                <div className="shape" />
                <div className="container">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 order-2 order-lg-1">
                            <div className="menu-info-wrapper d-flex flex-column justify-content-start h-100">
                                <div className="social-icon-wrap">
                                    <p>Check onze socials</p>
                                    <div className="icon-wrap">
                                        <a href={extraFields?.socials_facebook}>
                                            <i className="fa-brands fa-facebook-f" />
                                        </a>
                                        <a href={extraFields?.socials_instagram}>
                                            <i className="fa-brands fa-instagram" />
                                        </a>
                                        <a href={extraFields?.socials_linkedin}>
                                            <i className="fa-brands fa-linkedin-in" />
                                        </a>
                                    </div>
                                </div>
                                <NieuwsbriefForm />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6 order-1 order-lg-1 d-flex flex-column align-items-start">
                            <div className="main-menu hover-effect">
                                <ul>
                                    {menu?.map((e, i) => (
                                        <li key={i}>
                                            <Link className={isTip(e)} to={`/${e.url_titel}`}>
                                                {e.titel}
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
